import * as lit from "lit";
import { repeat } from "lit/directives/repeat.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export class LitComponent extends lit.LitElement {
  lit = lit;
  unsafeHTML = unsafeHTML;
  repeat = repeat;
}
